export default __webpack_public_path__ + "static/media/IBimageHipextensionTerminalStance1.437b5386.png";